import { unlikeAudioUrl, withQuery } from '@core/api'
import { httpClient } from '@core/http-client'

export const unlikeAudio = (id: string, signal?: AbortSignal) => {
    return httpClient.delete(withQuery(unlikeAudioUrl(), { id }), { signal }).json()
}
